function Header() {
    return(
        <div className='header'>
            <img src='https://i.imgur.com/986JIcQ.jpg' alt='avatar' />
            <h1 className='name'>
                Willie the Pack Mack
            </h1>
        </div>
    )
}

export default Header